<!-- <h4 class="text-lg font-bold">
  @if (((openedModals$ | async) ?? 0) > 1) {
    <i (click)="close(undefined)" class="fa-regular fa-angle-left"></i>
  }
</h4> -->

<div class="tableFixHead pr-2">
  @if (timeReports$ | async; as timeReports) {
    <table class="soft-table">
      <thead>
        <tr>
          @if (seeAllPermission()) {
            <th>
              {{ '#TICKETS.DIALOGS.TIME_REPORT.PERSONAL' | translate }}
            </th>
          }
          <th>{{ '#TICKETS.DIALOGS.TIME_REPORT.DATE' | translate }}</th>
          <th class="text-right">
            {{ '#TICKETS.DIALOGS.TIME_REPORT.DURATION' | translate }}
          </th>
        </tr>
      </thead>
      <tbody>
        @for (timeReport of timeReports; track timeReport) {
          <tr class="group hover:bg-hover rounded">
            @if (seeAllPermission()) {
              <td class="group-hover:rounded-l">{{ timeReport.person?.name }}</td>
            }
            <td>{{ timeReport.date | format: 'DATE.DEFAULT' }}</td>
            <td class="group-hover:rounded-r">
              <div class="text-middle flex items-center justify-between">
                <span>{{ timeReport.duration | format: 'DURATION.DEFAULT' }}</span>
                <div
                  softToolTip="Eintrag bearbeiten"
                  class="text-primary bg-primary-50 rounded-full p-3 cursor-pointer hover:bg-hover"
                  [class.hidden]="
                    !isToday(timeReport.date) ||
                    ((seeAllPermission()) &&
                      personalId() !== timeReport.person?.id)
                  "
                  (click)="edit(timeReport, 'update')"
                >
                  <soft-icon name="fa-regular fa-pen-to-square"></soft-icon>
                </div>
              </div>
            </td>
          </tr>
        }
        @if (timeReports.length === 0) {
          <tr class="group hover:bg-hover">
            <td class="group-hover:rounded-l">
              {{ '#TICKETS.DIALOGS.TIME_REPORT.NO_DATA' | translate }}
            </td>
            <td></td>
            <td class="text-right" class="group-hover:rounded-r">
              <div
                softToolTip="Arbeitszeit hinzufügen"
                class="flex justify-center mt-2 text-primary bg-primary-50 rounded-full p-3 cursor-pointer hover:bg-hover"
                (click)="edit(undefined, 'create')"
              >
                <soft-icon name="fa-regular fa-plus"></soft-icon>
                <span>{{ '#TICKETS.DIALOGS.TIME_REPORT.ADD' | translate }}</span>
              </div>
            </td>
          </tr>
        }
      </tbody>
    </table>
  }
</div>
@if (((timeReports$ | async)?.length ?? 0) > 0) {
  <div class="flex justify-center mt-2">
    <div
      softToolTip="Arbeitszeit hinzufügen"
      class="inline-flex text-primary bg-primary-50 rounded-full p-3 cursor-pointer hover:bg-hover"
      (click)="edit(undefined, 'create')"
    >
      <soft-icon name="fa-regular fa-plus"></soft-icon>
      <span>{{ '#TICKETS.DIALOGS.TIME_REPORT.ADD' | translate }}</span>
    </div>
  </div>
  <!-- <div class="flex flex-col end mt-2">
    <a class="pointer" (click)="edit(undefined, 'create')">
      <i class="fa-regular fa-plus mr-2"></i>
      <span>{{ '#TICKETS.DIALOGS.TIME_REPORT.ADD' | translate }}</span>
    </a>
  </div> -->
}
@if (action) {
  <div class="mt-2">
    <hr />
    <div class="mt-2">
      @switch (action) {
        @case ('create') {
          <div class="flex flex-row justify-between">
            <h5 class="font-bold">
              {{ '#TICKETS.DIALOGS.TIME_REPORT.CREATE.TITLE' | translate }}
            </h5>
            <a class="pointer" (click)="cancelEdit()"
              ><i class="fa-regular fa-angle-up"></i
            ></a>
          </div>
          <form [formGroup]="form">
            <div class="flex flex-row flex-nowrap mt-4">
              <div class="flex flex-col mr-2">
                <span class="soft-label top">{{
                  '#TICKETS.DIALOGS.TIME_REPORT.DATE' | translate
                }}</span>
                <soft-date-input
                  [readonly]="true"
                  formControlName="date"
                ></soft-date-input>
              </div>
              <div class="flex flex-col ml-2">
                <span class="soft-label top">{{
                  '#TICKETS.DIALOGS.TIME_REPORT.DURATION' | translate
                }}</span>
                <soft-duration-input formControlName="duration"></soft-duration-input>
              </div>
            </div>
            <div class="flex flex-row justify-end mt-2">
              <button
                type="submit"
                class="soft-button primary rounded hover:cursor-pointer"
                (click)="save(form.value, action)"
              >
                {{ '#TICKETS.DIALOGS.TIME_REPORT.CREATE.SUBMIT' | translate }}
              </button>
            </div>
          </form>
        }
        @case ('update') {
          <div class="flex flex-row justify-between">
            <h5 class="font-bold">
              {{ '#TICKETS.DIALOGS.TIME_REPORT.UPDATE.TITLE' | translate }}
            </h5>
            <a class="pointer" (click)="cancelEdit()"
              ><i class="fa-regular fa-angle-up"></i
            ></a>
          </div>
          <form [formGroup]="form">
            <div class="flex flex-row flex-nowrap mt-4">
              <div class="flex flex-col mr-2">
                <span class="soft-label top">{{
                  '#TICKETS.DIALOGS.TIME_REPORT.DATE' | translate
                }}</span>
                <soft-date-input
                  [readonly]="true"
                  formControlName="date"
                ></soft-date-input>
              </div>
              <div class="flex flex-col ml-2">
                <span class="soft-label top">{{
                  '#TICKETS.DIALOGS.TIME_REPORT.DURATION' | translate
                }}</span>
                <soft-duration-input formControlName="duration"></soft-duration-input>
              </div>
            </div>
            <div class="flex flex-row justify-end mt-2">
              <button
                type="submit"
                class="soft-button rounded hover:cursor-pointer hover:text-danger"
                (click)="edit(form.value, 'delete')"
              >
                {{ '#TICKETS.DIALOGS.TIME_REPORT.DELETE.ACTION' | translate }}
              </button>
              <button
                type="submit"
                class="soft-button primary rounded hover:cursor-pointer"
                (click)="save(form.value, action)"
              >
                {{ '#TICKETS.DIALOGS.TIME_REPORT.UPDATE.SUBMIT' | translate }}
              </button>
            </div>
          </form>
        }
        @case ('delete') {
          <div class="flex flex-row justify-between">
            <h5 class="font-bold">
              {{ '#TICKETS.DIALOGS.TIME_REPORT.DELETE.TITLE' | translate }}
            </h5>
            <a class="pointer" (click)="cancelEdit()"
              ><i class="fa-regular fa-angle-up"></i
            ></a>
          </div>
          <div class="mt-4">
            {{ '#TICKETS.DIALOGS.TIME_REPORT.DELETE.MESSAGE' | translate }}
          </div>
          <div class="flex flex-row justify-end mt-2">
            <button
              type="submit"
              class="soft-button rounded hover:cursor-pointer"
              (click)="edit(form.value, 'update')"
            >
              {{ '#TICKETS.DIALOGS.TIME_REPORT.DELETE.CANCEL' | translate }}
            </button>
            <button
              type="submit"
              class="soft-button primary rounded hover:cursor-pointer"
              (click)="save(form.value, action)"
            >
              {{ '#TICKETS.DIALOGS.TIME_REPORT.DELETE.SUBMIT' | translate }}
            </button>
          </div>
        }
      }
    </div>
  </div>
}
